// Component: TopicPanel
// Author: Mito Are
import React from 'react';
import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import TopicList from '@component/TopicList';
import WBRString from '@component/WbrString';
import { RoutableLink } from '../../react/RoutableLink';

const TopicLinksCard = (props) => {
  const linkList = [];
  props.fields?.children?.map((link, i) => {
    linkList.push(
      <>
        <RoutableLink field={link.fields?.link} key={i} useATag={true}>
          <WBRString tag="span">
            <Text field={link.fields?.linktext} />
          </WBRString>
        </RoutableLink>
      </>
    );
  });

  return <>{props?.fields?.children.length > 0 && <TopicList linkTitle={<Text field={props.fields?.title} />} links={linkList} />}</>;
};
export default withSitecoreContext()(TopicLinksCard);
